import { useMutation, gql } from '@apollo/client';
import {
  Mutation,
  MutationCreateContactArgs,
} from '@lgg/isomorphic/types/__generated__/graphql';

const CREATE_CONTACT_MUTATION = gql`
  mutation CreateContact(
    $institutionId: Int!
    $input: CreateContactInput!
    $allowDuplicates: Boolean!
  ) {
    createContact(
      institutionId: $institutionId
      input: $input
      allowDuplicates: $allowDuplicates
    ) {
      contact {
        id
        label
      }
    }
  }
`;

export const useCreateContact = () => {
  const [createContact, { loading: isCreatingContact }] = useMutation<
    Pick<Mutation, 'createContact'>,
    MutationCreateContactArgs
  >(CREATE_CONTACT_MUTATION);

  return {
    isCreatingContact,
    createContact,
  };
};
